import React from "react";

//styling
import "./clusterRow.css";

//for loading animation
import "react-placeholder/lib/reactPlaceholder.css";
import ReactPlaceholder from "react-placeholder";

const ClusterRowInfoPlaceholder = () => {
  return (
    <div
      style={{ padding: "10px 0", overflowY: "hidden" }}
      className="__clusterRowInfo"
    >
      <ReactPlaceholder
        type="textRow"
        showLoadingAnimation
        style={{ width: "145px", height: "20px" }}
      ></ReactPlaceholder>
    </div>
  );
};

export default ClusterRowInfoPlaceholder;
